import moment from 'moment/moment';
import * as niveauDispo from '@/components/creationOpportunite/configuration/DisponibiliteConf';
import { OPTION, BLOQUE, RELANCE_OPTION } from '@/configuration/optionBlocage';
import { TYPE_DEVIS, ETAT_ENREGISTRE, ETAT_COMMANDE_PARTIELLEMENT, ETAT_BROUILLON } from '@/configuration/devisConf';

const etatPlanning = {
  LIBRE: 0,
  OPTION: 1,
  PARTIEL: 2,
  OCCUPE: 3,
};

const maxAnnonceurLength = 16;

function getMaxAnnonceurLength() {
  // A adapter si responsive design sur le planning
  return Math.round((window.innerWidth - 800) / 1100 * maxAnnonceurLength);
}

function getAffectation(allAffectations, etatObtenu, referenceType, referenceEtat, rang) {
  let finalAffectation = null;
  allAffectations.filter((affectation) => {
    return affectation.etatObtenu === etatObtenu
    && affectation.referenceType === referenceType
    && affectation.referenceEtat === referenceEtat
    && affectation.rangOption === rang;
  }).forEach((affectation) => {
    if (!finalAffectation
      || affectation.nbFaces > finalAffectation.nbFaces
      || (affectation.nbFaces === finalAffectation.nbFaces
        && finalAffectation.libelle.localeCompare(affectation.libelle)) > 0) {
      finalAffectation = affectation;
    }
  });
  return finalAffectation;
}

function getAnnonceurBloquer(affectationsReseau) {
  const allAffectations = affectationsReseau.filter((affectation) => {
    return affectation.etatObtenu === BLOQUE;
  });
  if (allAffectations.length === 0) return null;
  if (allAffectations.length > 1) return `Ann. : ${allAffectations.length}`;
  return allAffectations[0].libelle;
}

function getAnnonceur(allAffectations) {
  if (allAffectations.length === 0) return null;
  let affectationFind = getAffectation(allAffectations, RELANCE_OPTION,
    TYPE_DEVIS, ETAT_ENREGISTRE, null);
  if (affectationFind) return affectationFind.libelle;
  affectationFind = getAffectation(allAffectations, RELANCE_OPTION,
    TYPE_DEVIS, ETAT_COMMANDE_PARTIELLEMENT, null);
  if (affectationFind) return affectationFind.libelle;
  affectationFind = getAffectation(allAffectations, RELANCE_OPTION,
    TYPE_DEVIS, ETAT_BROUILLON, null);
  if (affectationFind) return affectationFind.libelle;
  affectationFind = getAffectation(allAffectations, OPTION,
    TYPE_DEVIS, ETAT_ENREGISTRE, 1);
  if (affectationFind) return affectationFind.libelle;
  affectationFind = getAffectation(allAffectations, OPTION,
    TYPE_DEVIS, ETAT_COMMANDE_PARTIELLEMENT, 1);
  if (affectationFind) return affectationFind.libelle;
  affectationFind = getAffectation(allAffectations, OPTION,
    TYPE_DEVIS, ETAT_BROUILLON, 1);
  return affectationFind ? affectationFind.libelle : null;
}

export default function decorateurRectangleReseauxTempo(result,
  showAnnonceur,
  casePlanning,
  dateVar,
  reseauxTempoPanier,
  data) {
  let etat = etatPlanning.LIBRE;
  result.x1 += 0.5;
  result.x2 -= 0.5;
  result.width = result.x2 - result.x1;
  result.widthBlocage = 0;
  result.dateStart = dateVar.clone();
  result.checked = false;
  result.option = '';
  result.semaine = moment(dateVar).isoWeek();
  result.annee = moment(dateVar).isoWeekYear();
  if (showAnnonceur) {
    let annonceur = (casePlanning === undefined ? '' : casePlanning.annonceur);
    if (casePlanning && casePlanning.affectations) {
      annonceur = getAnnonceurBloquer(casePlanning.affectations);
      if (!annonceur) {
        annonceur = getAnnonceur(casePlanning.affectations);
      }
    }
    result.annonceurComplet = annonceur;
    result.annonceur = annonceur;
    if (result.annonceur && result.annonceur.length > getMaxAnnonceurLength()) {
      result.annonceur = result.annonceur.substring(0, getMaxAnnonceurLength());
      // Les caractères suivants prennent plus de largeur
      // Pour éviter les chevauchements on les détecte et on raccourci la chaine
      const largeCharacters = result.annonceur.match(/(M|W)/g) || [];
      if (largeCharacters.length >= 2) {
        result.annonceur = result.annonceur.substring(0,
          getMaxAnnonceurLength() - (largeCharacters.length));
      }
      result.annonceur += '\u2026'; // Unicode pour ...
    }
  }
  if (casePlanning !== undefined && casePlanning.existeOption) {
    etat = etatPlanning.OPTION;
  }
  reseauxTempoPanier.forEach((el) => {
    if (data.num === el.num &&
      el.extensionOpportunite.semaine === result.semaine &&
      el.extensionOpportunite.annee === result.annee) {
      result.checked = true;
      result.option = el.extensionOpportunite.demande;
    }
  });
  if (casePlanning !== undefined && casePlanning.estVendu
    && casePlanning.quantiteVendue > 0
    && casePlanning.facesPrevues > 0) {
    etat = etatPlanning.PARTIEL;
    let pourcentageVente = casePlanning.quantiteVendue / casePlanning.facesPrevues * 100;
    if (pourcentageVente >= 100) {
      pourcentageVente = 0;
      etat = etatPlanning.OCCUPE;
    }
    result.widthBlocage = result.width * pourcentageVente / 100;
  }
  switch (etat) {
    case etatPlanning.LIBRE:
      result.stroke = niveauDispo.COULEUR_DISPO_DISPONIBLE;
      result.fill = niveauDispo.COULEUR_BLANCHE;
      result.textColor = '#2c3e50';
      break;
    case etatPlanning.OPTION:
      result.stroke = niveauDispo.COULEUR_DISPO_PARTIELLEMENT;
      result.fill = niveauDispo.COULEUR_DISPO_OPTION;
      result.textColor = '#2c3e50';
      break;
    case etatPlanning.PARTIEL:
      result.stroke = niveauDispo.COULEUR_DISPO_PARTIELLEMENT;
      result.fill = niveauDispo.COULEUR_BLANCHE;
      result.colorOccupation = niveauDispo.COULEUR_DISPO_PARTIELLEMENT;
      result.textColor = '#2c3e50';
      break;
    case etatPlanning.OCCUPE:
    default:
      result.stroke = niveauDispo.COULEUR_DISPO_INDISPONIBLE;
      result.fill = niveauDispo.COULEUR_DISPO_INDISPONIBLE;
      result.textColor = niveauDispo.COULEUR_BLANCHE;
      break;
  }
  if (casePlanning !== undefined) {
    result.endString = (casePlanning.facesPrevues - casePlanning.quantiteVendue).toString() +
    '/' + casePlanning.facesPrevues;
  } else {
    result.endString = '';
  }
  ['x1', 'x2', 'widthBlocage', 'width'].forEach((key) => {
    result[key + 'String'] = result[key] + '%';
  });
}

export function isDispo(casePlanning) {
  const pourcentageVente = casePlanning.quantiteVendue / casePlanning.facesPrevues * 100;
  if (pourcentageVente >= 100) {
    return false;
  }
  return true;
}



// WEBPACK FOOTER //
// ./src/services/decorateur/decorateurRectangleReseauxTempo.js